import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { TiendaService } from '../../services/tienda.service';
import { Tienda } from '../../models/tienda';
import { ToastMensajeService } from '../../services/mensaje-toast.service';
import { PrintPagoHelper, TipoPago } from '../../models/printPagoHelper';
import { NgIf } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-print-pago-modal',
  templateUrl: './print-pago-modal.component.html',
  styleUrls: ['./print-pago-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrintPagoModalComponent implements OnInit {

  @Input() printPagoHelper: PrintPagoHelper; // se abre despues de pago por lo que llega que se guardó correctamente

  @Output() close = new EventEmitter<void>();

  public tienda: Tienda;
  public tipoPago: TipoPago;
  TipoPago = TipoPago;
  public precio = 0;

  constructor(
    private utilsService: UtilsService,
    private tiendaService: TiendaService,
    protected toastService: ToastMensajeService
  ) { }

  ngOnInit(): void {
    this.getTienda();
    this.tipoPago = this.getTipoPago();
    this.manageDatosSegunTipoPago();
    this.openModal();
    if (this.printPagoHelper.mensajeOk) {
      this.toastService.mostrarMensajeOK(this.printPagoHelper.mensajeOk);
    }
  }

  openModal(): void {
    $('#pagoModal').show();
  }

  getTipoPago(): TipoPago {
    if (this.printPagoHelper.ticket) return TipoPago.Ticket;
    if (this.printPagoHelper.bonomove) return TipoPago.Bonomove;
    if (this.printPagoHelper.financiacionPago) return TipoPago.Financiacion;
    if (this.printPagoHelper.devolucion) return TipoPago.Devolucion;
    return TipoPago.Desconocido;
  }

  getTiendaId(): number {
    return (
      this.printPagoHelper.ticket?.tiendaId ||
      this.printPagoHelper.bonomove?.tiendaId ||
      this.printPagoHelper.financiacionPago?.tiendaId ||
      this.utilsService.getCurrentTiendaId()
    );
  }

  manageDatosSegunTipoPago() {
    switch (this.tipoPago) {
      case TipoPago.Bonomove:
        this.precio = this.printPagoHelper.bonomove.pagoFinanciado ? this.printPagoHelper.bonomove.quedaPorPagar + this.printPagoHelper.bonomove.totalAPagar : this.printPagoHelper.bonomove.totalAPagar;
        break;

      case TipoPago.Financiacion:
        const importePagado = Array.isArray(this.printPagoHelper.financiacionPago.financiacion.pagosFinanciacion)
          ? this.printPagoHelper.financiacionPago.financiacion.pagosFinanciacion.reduce((acc, pago) => acc + Number(pago.pagadoEnPlazo || 0), 0)
          : 0;
        this.precio = (this.printPagoHelper.financiacionPago.financiacion.importeFinanciacion - importePagado) + this.printPagoHelper.financiacionPago.pagadoEnPlazo
        break;
      default:
        // case TipoPago.Ticket:

        break;
    }

    this.precio = this.printPagoHelper.totalPagar || 0;
  }

  getTienda() {
    this.tiendaService.getTiendaById(this.getTiendaId())
      .subscribe(data => {
        this.tienda = data;
      },
        error => {
          var errorMessage = <any>error;
          if (errorMessage != null) {
            this.toastService.mostrarMensajeError(error.error.message);
          }
        })
  }

  imprimirTicket() {
    window.print();

  }

  onClose(): void {
    this.close.emit();
  }



}
